// extracted by mini-css-extract-plugin
export default {"headerWrapper":"AboutTheTeam_headerWrapper__-5yNt","card":"AboutTheTeam_card__UQcUg","twitter":"AboutTheTeam_twitter__gTsmG","cardHeader":"AboutTheTeam_cardHeader__O37-u"};